<template>
    <div class="dropdown-navigation">
        <!-- <pre v-if="content" v-text="content"></pre> -->
        <cmp-form-field-select v-if="content.menu"
                :items="content.menu.items"
                v-model="routePath">
        </cmp-form-field-select>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            routePath: {
                get() {
                    return this.$route.path;
                },
                set(val) {
                    if (!val) {
                        return;
                    }

                    this.$router.push(val);
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?77d239d2